import { AlertTitle } from "@mui/material";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import PropTypes from "prop-types";
import "@/components/Notifications/Notifications.css";

function Notifications({ notification, setNotification }) {
  return (
    <Snackbar
      id="notification-component"
      open={!!notification}
      autoHideDuration={notification?.duration || null}
      onClose={() => setNotification("")}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
    >
      {notification && (
        <Alert
          onClose={() => setNotification("")}
          severity={notification.severity || "info"}
          sx={{ width: "100%" }}
        >
          <AlertTitle>{notification.title}</AlertTitle>
          {notification.message}
        </Alert>
      )}
    </Snackbar>
  );
}

Notifications.propTypes = {
  notification: PropTypes.object,
  setNotification: PropTypes.func,
};

export default Notifications;
